import { useState } from "react";
import Drawer from "./mobile/Drawer";
import Footer from "./main/Footer";
import Header from "./main/Header";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { useTheme } from "../Theme";

export default function Layout() {
  const [drawer, setDrawer] = useState(false);
  const { darkMode } = useTheme();
  const location = useLocation();

  const isDashboard = location.pathname.startsWith("/dashboard");

  const layoutClasses = darkMode
    ? "bg-slate-800 text-white"
    : "bg-white text-black";

  return (
    <>
      {drawer && <Drawer open={drawer} action={() => setDrawer(!drawer)} />}
      <div className={`w-full overflow-x-hidden ${layoutClasses}`}>
        <ScrollRestoration />

        {!isDashboard && <Header drawerAction={() => setDrawer(!drawer)} />}

        <div className={`w-full pt-0 pb-0 ${layoutClasses}`}>
          <Outlet />
        </div>

        {!isDashboard && <Footer />}
      </div>
    </>
  );
}
